<template>
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="14" height="14" fill="white" />
        <path
            d="M9.20983 5.34396H8.88354V4.69132C8.88354 3.79074 8.15263 3.05981 7.25206 3.05981C6.3515 3.05981 5.62058 3.79074 5.62058 4.69132V5.34396H5.29429C4.93537 5.34396 4.64166 5.63761 4.64166 5.99654V9.25961C4.64166 9.61854 4.93531 9.91225 5.29429 9.91225H9.20989C9.56882 9.91225 9.86252 9.6186 9.86252 9.25961V5.99654C9.86252 5.63761 9.56882 5.34396 9.20983 5.34396ZM7.25206 8.45124C6.86302 8.45124 6.54758 8.13579 6.54758 7.74674C6.54758 7.3577 6.86302 7.04219 7.25206 7.04219C7.6411 7.04219 7.9566 7.35764 7.9566 7.74674C7.9566 8.13585 7.64116 8.45124 7.25206 8.45124ZM8.23092 5.34396H6.27315V4.69132C6.27315 4.14961 6.71036 3.71239 7.252 3.71239C7.79364 3.71239 8.23092 4.14961 8.23092 4.69132V5.34396Z"
            fill="#8291B0"
        />
        <path
            d="M12.5252 3.00774C11.599 1.59322 10.1552 0.527634 8.39354 0.147264C4.87011 -0.613475 1.45731 1.64821 0.757223 5.19921C0.746503 5.25371 0.736446 5.30815 0.727112 5.36259L2.31415 5.70526C2.323 5.65076 2.33282 5.59626 2.3436 5.5417C2.86784 2.88248 5.43819 1.18431 8.07677 1.75408C9.40003 2.03984 10.4705 2.84888 11.1588 3.91049L9.76914 4.52922L13.2008 6.10593L13.9999 2.37841L12.5252 3.00774Z"
            fill="#8291B0"
        />
        <path
            d="M1.50411 10.1601C2.35891 11.6191 3.74794 12.7557 5.48854 13.2237C8.96976 14.1599 12.4907 12.0718 13.3663 8.56027C13.3797 8.50637 13.3925 8.45247 13.4045 8.39857L11.8365 7.97688C11.8248 8.03084 11.8124 8.0848 11.7989 8.13876C11.1432 10.7685 8.49165 12.3359 5.88469 11.6348C4.57726 11.2832 3.5483 10.4215 2.91362 9.32685L4.33227 8.77845L0.983189 7.03198L-0.00012207 10.7149L1.50411 10.1601Z"
            fill="#8291B0"
        />
    </svg>
</template>

<script>
export default {
    name: 'CircleLock',
};
</script>
